module.exports = __webpack_public_path__ + "img/CHEL.1094ce7a.png";